import { uuid } from '../utils/uuid';
import { uri } from '../utils/config';

class WebSockets {
  static getInstance() {
    if (!WebSockets.instance) {
      WebSockets.instance = new WebSockets();
    }
    return WebSockets.instance;
  }

  constructor() {
    this.placeId = null;
    this.userId = null;
    this.connection = null;
    this.isConnecting = null;
    this.onMessage = null;
    this.reconnectInteraval = null;
    this.checkInterval = null;
    this.callback = () => null;
    this.forcedDisconnect = false;
    this.refreshEvent = new Event('refresh_places_and_events');
  }

  clear() {
    console.log('CLEARING WEBSOCKETS');
    this.placeId = null;
    this.userId = null;
    this.connection = null;
    this.onMessage = null;
    clearInterval(this.reconnectInteraval);
    this.reconnectInteraval = null;
    clearInterval(this.checkInterval);
    this.checkInterval = null;
    this.callback = () => null;
    this.forcedDisconnect = false;
  }

  getIntegrity() {
    const hasPlaceId = typeof this.placeId === 'string' && this.placeId.length > 0;
    const hasUserId = typeof this.userId === 'string' && this.userId.length > 0;
    return hasPlaceId && hasUserId;
  }

  connectionCheckStop() {
    this.checkInterval && clearInterval(this.checkInterval);
    this.checkInterval = null;
  }

  setNewPlaceId(placeId) {
    const validPlaceId = typeof placeId === 'string' && placeId.length > 0;
    if (!validPlaceId) return;
    this.placeId = placeId;
  }

  setNewUserId(userId) {
    this.userId = userId;
  }

  setOnMessage(onMessage) {
    this.onMessage = onMessage;
  }

  setCallback(callback) {
    this.callback = callback;
  }

  disconnect() {
    this.forcedDisconnect = true;
    this.connection && this.connection.close();
    this.connection = null;
    this.callback(null);
    this.clear()
    console.log('WEBSOKETS SOCKETS CONNECTION CLOSED');
  }

  onReconnect(socket) {
    this.callback(socket);
  }

  onDisconect(socket) {
    this.callback(socket);
  }

  async connect() {
    if (!this.placeId || !this.userId) {
      console.error('NO PLACE ID AND TRYING TO CONNECT!');
      return;
    }

    return new Promise((resolve, reject) => {
      try {
        if (!this.getIntegrity()) {
          console.log('NOT ENOUGH DATA TO START');
          resolve();
        }
        if (this.isConnecting) {
          resolve();
        }
        this.isConnecting = true;
        console.log('INITIALIZING WEBSOKETS CONNECTION!');
        const socket = new WebSocket(uri.socket);
        socket.onmessage = (message) => {
          this.onMessage(message, this.connection);
        };
        socket.onopen = () => {
          const isTryingToReconnect = this.reconnectInteraval !== null;
          if (isTryingToReconnect) {
            this.cancelTryToReconnectOnConnected();
          }
          this.connection = socket;
          this.onReconnect(this.connection);
          const connectionData = JSON.stringify({ connectionId: this.placeId });
          socket.send(connectionData);
          console.log('WEBSOKETS SOCKETS CONNECTION OPEN');
          this.callback(socket);
          this.isConnecting = false;
          window.dispatchEvent(this.refreshEvent);
          resolve();
        };

        socket.onerror = (error) => {
          if (error.message) console.log('ERROR: ', error.message);
        };

        socket.onclose = () => {
          if (this.forcedDisconnect) {
            this.forcedDisconnect = false;
            this.connection = null;
            clearInterval(this.reconnectInteraval);
            this.reconnectInteraval = null;
            return;
          }
          const isTryingToReconnect = this.reconnectInteraval !== null;
          if (isTryingToReconnect) return;
          this.onReconnect(this.connection);
          this.tryToReconnect5times();
        };
      } catch (error) {
        console.error('Error starting the websockets server', error);
        reject();
      }
    });
  }

  tryToReconnect5times() {
    if (!this.placeId || !this.userId) {
      return;
    }
    console.log('TRYING TO RECONNECT 5 TIMES', this.placeId);
    let tries = 0;
    this.reconnectInteraval = setInterval(() => {
      if (tries < 5) {
        this.connect();
        tries += 1;
      } else {
        clearInterval(this.reconnectInteraval);
        this.reconnectInteraval = null;
        setTimeout(() => {
          !this.connection && this.connect();
        }, 10000);
      }
    }, 5000);
  }

  cancelTryToReconnectOnConnected() {
    console.log('CONNECTED, CANCELING RECONNECTION ATEMTPS!');
    clearInterval(this.reconnectInteraval);
    this.reconnectInteraval = null;
  }
}

const WebSocketsInstance = new WebSockets();

export { WebSocketsInstance as WebSockets };
